export const FETCH_PUBLICATIONS = 'FETCH_PUBLICATIONS';
export const UPDATE_PUBLICATIONS = 'UPDATE_PUBLICATIONS';
export const PROCESS_FILE_OFFERS = 'PROCESS_FILE_OFFERS';
export const UPDATE_OFFERS_FOR_PUBLISH = 'UPDATE_OFFERS_FOR_PUBLISH';
export const GET_MASTERDATA_MASIVE = 'GET_MASTERDATA_MASIVE';
export const SET_MASTERDATA_MASIVE = 'SET_MASTERDATA_MASIVE';
export const PUBLISH_OFFERS_MASIVE = 'PUBLISH_OFFERS_MASIVE';
export const GET_PUBLICATION_DETAIL = 'GET_PUBLICATION_DETAIL';
export const SET_PUBLICATION_DETAIL = 'SET_PUBLICATION_DETAIL';
export const GET_IMAGES_VEHICLE_ID = 'GET_IMAGES_VEHICLE_ID';
